export const USER_SINCE = "user-since";
export const NEWS_BANNER = "news-banner";
export const GLOBAL_NAV_EXPANDED = "global-nav-expanded";
export const LAST_WORKSPACE = "lastWorkspace";
export const JWT_TOKEN = "jwtToken";
export const REDIRECT_KEY = "redirect";
export const CHAT_BOT_POSITION_KEY = "chatbot-position";

export const KEYS_TO_RETAIN_ON_LOGOUT = [
  JWT_TOKEN,
  NEWS_BANNER,
  CHAT_BOT_POSITION_KEY,
  LAST_WORKSPACE,
  GLOBAL_NAV_EXPANDED,
];
